import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from "angular-datatables";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';
import { HighchartsChartModule } from 'highcharts-angular';
import { TWOFAFormComponent } from './2faForm/2FAForm.component';
import { MktCoopSharedComponent } from './mkt-coop/mkt-coop-shared.component';
import { MktBudgetGraphComponent } from './mkt-coop-budget-graph/mkt-coop-budget-graph.component';
import { CarruselComponent } from './carousel/carrusel.component';
import { NoveltyComponent } from './novelty/novelty.component';
import { ShortcutComponent } from './shortcut/shortcut.component';
import { AddTokenPipe } from '../../pipes/addToken';


@NgModule({
  declarations: [
    TWOFAFormComponent,
    MktCoopSharedComponent,
    MktBudgetGraphComponent,
    CarruselComponent,
    NoveltyComponent,
    ShortcutComponent,
    AddTokenPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    Select2Module,
    HighchartsChartModule
  ],
  exports: [
    TWOFAFormComponent,
    MktCoopSharedComponent,
    MktBudgetGraphComponent,
    CarruselComponent,
    NoveltyComponent,
    ShortcutComponent,
    AddTokenPipe
   
  ],
  providers: [
    DecimalPipe
  ]
})
export class SharedModule { }
